export default __webpack_public_path__ + "static/media/Hannover_Logo.20bee3df.png";